import React from "react";

export default function CertificadoEnProgreso({ datosCurso, onClose }) {
  return (
    <div className="tarjeta-certificado-en-progreso">
      <div className="tarjeta-certificado-en-progreso-info">
        <div className="tarjeta-certificado-en-progreso-titulos">
          <div className="tarjeta-certificado-en-progreso-titulos-1">
            <h2 className="tarjeta-certificado-en-progreso-titulo-1">
              ¡El éxito está cerca!
            </h2>
            <h3 className="tarjeta-certificado-en-progreso-titulo-2">
              Sigue trabajando
            </h3>
          </div>
          <p className="tarjeta-certificado-en-progreso-texto-1">
            {datosCurso?.nombre_curso}
          </p>
          <p className="tarjeta-certificado-en-progreso-texto-2">
            <span className="tarjeta-certificado-en-progreso-texto-2-0">
              Aún debes aprobar 
            </span>
            <span className="tarjeta-certificado-en-progreso-texto-2-1">
            {` ${datosCurso?.lecciones_completadas} `}
            </span>
            <span className="tarjeta-certificado-en-progreso-texto-2-0">
               evaluaciones para obtener tu certificado
            </span>
          </p>
        </div>
        <button className="boton-seguir-estudiando" onClick={onClose}>
          Seguir estudiando
        </button>
      </div>
      <div className="tarjeta-certificado-en-progreso-imagen">
        <img
          src="../images/Group.svg"
          alt="Grupo"
          width="50.94"
          height="51.03"
          loading="lazy"
          className="group"
        />
      </div>
    </div>
  );
}
